const UploadStatusLegend = () => (
  <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600 mb-3">
    <span className="font-medium">Upload status:</span>
    <span className="inline-flex items-center gap-1.5">
      <span className="w-3 h-3 rounded-full bg-amber-400 border border-amber-500" />
      Pending Upload
    </span>
    <span className="inline-flex items-center gap-1.5">
      <span className="w-3 h-3 rounded-full bg-green-500 border border-green-600" />
      Uploaded
    </span>
    <span className="inline-flex items-center gap-1.5">
      <span className="w-3 h-3 rounded-full bg-gray-200 border border-gray-300" />
      Not applicable
    </span>
  </div>
);

export default UploadStatusLegend;
